var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('div',{attrs:{"id":"map"}}),(_vm.map)?_c('map-settings',{attrs:{"map":_vm.map}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }